import React, { Component } from "react";
import RenderTable from "../common/table";
import { Icon, Label } from "semantic-ui-react";
import auth from "../../services/authService";
import parse from "html-react-parser";

class VehicleLedgerTable extends Component {
  columns = [
    {
      path: "payment_date",
      label: "Date",
      width: "2",
    },
    {
      path: "description",
      label: "Description",
      width: "5",
    },
    {
      path: "debit",
      label: "Debit",
      width: "2",
      content: (type) => (
        <div>
          {type.debit >= 0
            ? type.debit
            : parse("<span style='color:red'>(" + type.debit + ")</span>")}
        </div>
      ),
    },
    {
      path: "credit",
      label: "Credit",
      width: "2",
      content: (type) => (
        <div>
          {type.credit >= 0
            ? type.credit
            : parse("<span style='color:red'>(" + type.credit + ")</span>")}
        </div>
      ),
    },
    {
      path: "net_payment",
      label: "Net Balance",
      width: "2",
      content: (type) => (
        <div>
          {type.net_payment >= 0
            ? type.net_payment
            : parse(
                "<span style='color:red'>(" + type.net_payment + ")</span>"
              )}
        </div>
      ),
    },
    {
      key: "actions",
      width: "2",
      content: (type) =>
        auth.getCurrentUser().role === "company" && (
          <div>
            <Icon
              name="trash"
              color="red"
              className="clickable"
              onClick={() => this.props.onDelete(type)}
            />

            <Icon
              name="edit"
              color="blue"
              className="clickable"
              onClick={() => this.props.onUpdate(type)}
            />
          </div>
        ),
    },
  ];

  render() {
    const { payments, onSort, sortColumn } = this.props;

    return (
      <RenderTable
        columns={this.columns}
        data={payments}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default VehicleLedgerTable;
